// ── Smooth bottom-sheet entrances ─────────────────────────────────────────────
// A sheet's slide-up used to start in the same frame as the (heavy) render that
// mounted it, so its first ~100-300ms were spent while the main thread was busy
// and the motion stuttered or jumped (Jade, 2026-10-16: the habit Add amount
// sheet and the Clock-In assign sheet felt "crashy and delayed").
//
// The fix, same as the purchase page's fade (clarity-premium-wait): the sheet
// mounts with its entrance animation PAUSED on its first keyframe (off-screen),
// and the pause is lifted two frames later, once the mount has been painted. The
// whole slide then runs on a free main thread. The class is swapped on the DOM
// node directly, so lifting it costs no React render.
//
// Usage: give the animated element (and its dim, if that animates too) the class
// "sheet-enter-wait" next to its animation class, and pass `holdSheetEnter` as
// its ref (or call it from your own ref callback).

const CSS = `
.sheet-enter-wait { animation-play-state: paused !important; }
@media (prefers-reduced-motion: reduce) { .sheet-enter-wait { animation: none !important; } }
`;

if (typeof document !== "undefined" && !document.getElementById("sheet-enter-css")) {
  const el = document.createElement("style");
  el.id = "sheet-enter-css";
  el.textContent = CSS;
  document.head.appendChild(el);
}

export function holdSheetEnter(el) {
  if (!el || !el.classList.contains("sheet-enter-wait") || el._sheetEnterArmed) return;
  el._sheetEnterArmed = true;
  requestAnimationFrame(() => requestAnimationFrame(() => el.classList.remove("sheet-enter-wait")));
}
